<mat-expansion-panel [expanded]="expanded" (opened)="onPanelOpened()">
  <mat-expansion-panel-header>
    <mat-panel-title>
      {{title}}
    </mat-panel-title>
  </mat-expansion-panel-header>
  <ng-container *ngIf="expanded || hasBeenOpened">
    <ng-content class="full"></ng-content>
  </ng-container>
</mat-expansion-panel>